import { input, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export type TagColor = 'neutral' | 'accent' | 'danger' | 'success' | 'warning' | 'info';
export type TagSize = 'small' | 'medium' | 'large';
export type TagVariant = 'filled' | 'soft' | 'outlined' | 'surface';

@Component({
  selector: 'span[appTag]',
  imports: [],
  template: `
    <ng-content />
  `,
  styleUrl: './tag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class Tag {
  public readonly size = input<TagSize>('medium');
  public readonly color = input<TagColor>('neutral');
  public readonly variant = input<TagVariant>('soft');

  protected readonly hostClasses = computed(() => {
    return {
      'app-tag': true,
      [`app-tag_${this.size()}`]: true,
      [`app-tag_${this.variant()}`]: true,
      [`app-tag_${this.color()}`]: true,
    };
  });
}
